import Spouse from 'src/value-objects/Spouse';
import * as moment from 'moment';
import { Moment } from 'moment';
import SectorOfInterest from 'src/entities/SectorOfInterest';

interface InitialData {
  // tslint:disable-next-line:no-any
  [key: string]: any;
}

export default class PhysicalPersonData {
  id: number;
  name: string;
  surname: string;
  nationality?: string;
  idNumber?: string;
  idExpirationDate?: Moment;
  idFront?: {
    url: string,
    encoded?: string,
    ext?: string,
    name?: string,
  };
  idBack?: {
    url: string,
    encoded?: string,
    ext?: string,
    name?: string,
  };
  birthDate?: Moment;
  phoneNumber?: string;
  notificationEmail?: string;
  email?: string;
  address?: string;
  houseNumber?: string;
  zipCode?: string;
  city?: string;
  province?: string;
  country?: string;
  maritalStatus?: string;
  maritalEconomicStatus?: string;
  maritalPropertyRegime?: string;
  occupationType?: string;
  occupation?: string;
  company?: string;
  spouse?: Spouse;
  profilePicture?: {
    url: string,
    encoded?: string,
    ext?: string,
    name?: string,
  };
  facebookProfile?: string;
  twitterProfile?: string;
  linkedinProfile?: string;
  about?: string;
  investmentGoal?: string;
  sectorsOfInterest: SectorOfInterest[];
  personType: string;
  displayName: string;
  investorType?: string;
  isPublicProfile?: boolean;

  constructor(entity: InitialData) {
    this.id = entity.id;
    this.name = entity.name;
    this.displayName = entity.displayName || '';
    this.surname = entity.surname;
    this.nationality = entity.nationality || undefined;
    this.idNumber = entity.idNumber || undefined;
    this.idExpirationDate = entity.idExpirationDate ? moment.utc(entity.idExpirationDate) : undefined;
    this.idFront = typeof entity.idFront === 'object' ? entity.idFront : { url: entity.idFront };
    this.idBack = typeof entity.idBack === 'object' ? entity.idBack : { url: entity.idBack };
    this.birthDate = entity.birthDate ? moment.utc(entity.birthDate) : undefined;
    this.phoneNumber = entity.phoneNumber || undefined;
    this.notificationEmail = entity.notificationEmail || undefined;
    this.email = entity.email || undefined;
    this.address = entity.address || undefined;
    this.houseNumber = entity.houseNumber || undefined;
    this.zipCode = entity.zipCode || undefined;
    this.city = entity.city || undefined;
    this.province = entity.province || undefined;
    this.country = entity.country || undefined;
    this.maritalStatus = entity.maritalStatus || undefined;
    this.maritalEconomicStatus = entity.maritalEconomicStatus || undefined;
    this.maritalPropertyRegime = entity.maritalPropertyRegime || undefined;
    this.occupationType = entity.occupationType || undefined;
    this.occupation = entity.occupation || undefined;
    this.company = entity.company || undefined;
    this.spouse = entity.spouse ? new Spouse(entity.spouse) : undefined;
    this.profilePicture = typeof entity.profilePicture === 'object' ?
      entity.profilePicture :
      { url: entity.profilePicture };
    this.facebookProfile = entity.facebookProfile || undefined;
    this.twitterProfile = entity.twitterProfile || undefined;
    this.linkedinProfile = entity.linkedinProfile || undefined;
    this.about = entity.about || undefined;
    this.investmentGoal = entity.investmentGoal || undefined;
    this.sectorsOfInterest = entity.sectorsOfInterest ?
      entity.sectorsOfInterest.map((sector: SectorOfInterest) => new SectorOfInterest(sector)) :
      [];
    this.personType = entity.personType;
    this.investorType = entity.investorType;
    this.isPublicProfile = entity.isPublicProfile || false;
  }
}



// WEBPACK FOOTER //
// ./src/value-objects/PhysicalPersonData.tsx